import { SafetyCertificateOutlined } from "@ant-design/icons";
import { FC, useState } from "react";

import { isManagerRole } from "@/hooks/isManagerRole";
import { useAppSelector } from "@/hooks/redux";

import { StyledButton } from "./Styled";
import { SVScanModal } from "./SVScanModal";

interface SVScanButtonProps {
    taskId: string;
    marketId: string;
}

export const SVScanButton: FC<SVScanButtonProps> = ({ taskId, marketId }) => {
    const { role } = useAppSelector((s) => s.user);
    const { supervisorCheck } = useAppSelector((s) => s.work);
    const checked = !!supervisorCheck[taskId] || isManagerRole(role);

    const [open, setOpen] = useState(false);

    return (
        <>
            <StyledButton
                $checked={checked}
                type="text"
                onClick={() => setOpen(true)}
                icon={<SafetyCertificateOutlined style={{ fontSize: 20 }} />}
            />

            <SVScanModal
                open={open}
                taskId={taskId}
                marketId={marketId}
                onClose={() => setOpen(false)}
            />
        </>
    );
};
